import React from "react";

function PonticModel(props) {
  const { model, visible = true, opacity = 1 } = props;

  const currentClickPontic = 1;
  const itemId = 2;

  return (
    <mesh
      geometry={model}
      matrixAutoUpdate={false}
    //   onClick={(event) => clickHandler(event)}
      visible={visible}
      renderOrder={2}
    >
      <meshStandardMaterial
        color={currentClickPontic == itemId ? "orange" : "#C0C0C0"}
        opacity={opacity}
        transparent={true}
        depthWrite={opacity > 0.5 ? true : false}
        roughness={0.4}
        metalness={0}
        reflectivity={0.3}
        emissive={"#fff"}
        emissiveIntensity={0.05}
      />
    </mesh>
  );
}

export default PonticModel;
